import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueI18n from "vue-i18n";
Vue.config.productionTip = false
Vue.use(VueI18n);

let lang = new URL(window.location.href).searchParams.get('lang'), lang1 = localStorage.getItem("nissan2023_meeting_lang");
if (lang) {
    localStorage.setItem("nissan2023_meeting_lang", lang);
} else if (lang1) {
    localStorage.setItem("nissan2023_meeting_lang", lang1);
} else {
    localStorage.setItem("nissan2023_meeting_lang", 'zh');
}

const i18n = new VueI18n({
    locale: localStorage.getItem("nissan2023_meeting_lang"),
    silentTranslationWarn: true,
    messages: {
        zh: require("./i18n/zh"),
        jp: require("./i18n/jp")
    }
});
import axios from 'axios'

// import './uilt/vconsole';

import AlloyFinger from 'alloyfinger'
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue'

Vue.use(AlloyFingerPlugin, {
    AlloyFinger
})



import VueAxios from 'vue-axios'
axios.defaults.baseURL = 'https://sapi.event1.cn/cc3eke2d3nyqzawx/';
Vue.use(VueAxios, axios)

// 添加一个请求拦截器
axios.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    return Promise.reject(error);
});

import { CanvasScaleToWindow } from './Toolset'
let vhtml = document.body;
CanvasScaleToWindow(vhtml)

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js